"use client";

import { NAV_ITEMS } from "@consts/navigation";
import Link from "next/link";
import { useState } from "react";
import IconButton from "../Button/IconButton";
import CloseIcon from "../Icons/CloseIcon";
import MenuIcon from "../Icons/MenuIcon";

const PANEL_ID = "mobile-menu";

export default function MobileMenu() {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="lg:hidden">
			<IconButton
				icon={isOpen ? <CloseIcon /> : <MenuIcon />}
				label={isOpen ? "Закрыть меню" : "Открыть меню"}
				size="sm"
				shape="square"
				aria-expanded={isOpen}
				aria-controls={PANEL_ID}
				onClick={() => setIsOpen((open) => !open)}
			/>

			{isOpen && (
				<nav
					id={PANEL_ID}
					className="absolute inset-x-0 top-full flex flex-col border-t border-stroke bg-background px-5 py-2"
				>
					{NAV_ITEMS.map(({ label, href }) => (
						<Link
							key={label}
							href={href}
							onClick={() => setIsOpen(false)}
							className="py-3 text-base font-medium"
						>
							{label}
						</Link>
					))}
				</nav>
			)}
		</div>
	);
}
